/* eslint-disable react/no-danger */
import { ReactElement } from "react";
import { Link } from "@inertiajs/react";
import ActivityType from "types/ActivityType";
import { BookButton } from "features/BookButton";
import BookReviewLink from "components/BookReview/BookReviewLink";
import BookContributors from "components/authors/BookContributors";
import BookMatchPercentage from "components/match/BookMatchPercentage/BookMatchPercentage";
import Stars from "components/BookReview/Stars";
import BookReviewText from "components/BookReview/BookReviewText";
import CoverLink from "components/Cover/CoverLink";
import UserBookActivitySnapshot from "types/UserBookActivitySnapshot";

export interface Props {
  activity: ActivityType;
  userBook?: UserBookActivitySnapshot;
  children?: ReactElement;
}

function UserBookActivity({
  activity,
  userBook,
}: {
  activity: ActivityType;
  userBook: UserBookActivitySnapshot;
}) {
  if (!userBook || (!userBook.rating && userBook.reviewSlate === null)) {
    return false;
  }

  return (
    <div className="mt-2">
      {userBook.reviewSlate && (
        <div className="w-full">
          <BookReviewText expanded={false} reviewSlate={userBook.reviewSlate} />

          <BookReviewLink userBook={userBook} />
          <p className="mt-2 text-right">
            <Link
              href={`/books/${
                activity.book.slug || activity.book.id
              }/reviews/@${activity.user.username}`}
              className="text-indigo-600 dark:text-yellow-400 hover:underline"
            >
              Read full review
            </Link>
          </p>
        </div>
      )}
    </div>
  );
}
export default function BookActivity({
  activity,
  userBook,
  children = <></>,
}: Props) {
  const { book } = activity;
  if (!book) {
    return <></>;
  }

  return (
    <div className="flex flex-col sm:flex-row gap-2 sm:gap-6 mt-2">
      <div className="flex justify-center  flex-col gap-4 w-full mt-2">
        <div className="flex gap-4 items-center">
          <CoverLink
            book={book}
            size="md"
            variant="secondary"
            className="flex-none self-start"
            settings={{
              stretch: "x",
              showStatus: true,
              tooltip: true,
              details: true,
              referrerId: activity.userId,
            }}
          />
          <div>
            <BookMatchPercentage bookId={book.id} />
            {children}
            <div className="flex flex-wrap gap-1 items-center">
              <Link
                href={`/books/${book.slug}`}
                className=" text-stone-800 dark:text-yellow-50 hover:underline sm:text-xl font-bold"
              >
                {book.title}
              </Link>
              <span className="text-gray-400">by</span>
              <BookContributors
                book={book}
                className="text-stone-800 dark:text-yellow-50 font-semibold hover:underline sm:text-xl"
              />{" "}
              {userBook?.rating > 0 && (
                <div className="w-full">
                  <Stars rating={userBook.rating} />
                </div>
              )}
              <div className="flex w-full p-1 mt-2">
                <BookButton referrerUserId={activity.userId} bookId={book.id} />
              </div>
            </div>

            <div className="hidden md:block">
              <UserBookActivity activity={activity} userBook={userBook} />
            </div>
          </div>
        </div>
        <div className="md:hidden">
          <UserBookActivity activity={activity} userBook={userBook} />
        </div>
      </div>
    </div>
  );
}
